import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

function initVideoSwiper() {
  document.querySelectorAll('.video-carousel-section').forEach(($section) => {
    const $swiperEl = $section.querySelector('.video-carousel');
    if (!$swiperEl) return;

    if ($swiperEl.swiper) {
      $swiperEl.swiper.destroy(true, true);
    }

    const slidesPerViewMobile = parseFloat($swiperEl.dataset.slidesPerViewMobile) || 1.5;
    const slidesPerViewDesktop = parseFloat($swiperEl.dataset.slidesPerViewDesktop) || 4.5;
    const gapMobile = parseFloat($swiperEl.dataset.gapMobile) || 16;
    const gapDesktop = parseFloat($swiperEl.dataset.gapDesktop) || 20;

    // No video plays until the visitor explicitly clicks one - once that's
    // happened, swiping/navigating to a new slide keeps the "something is
    // playing" experience going by auto-playing whichever slide becomes
    // active next.
    let hasStartedPlaying = false;

    function getVideo($slide) {
      return $slide && $slide.querySelector('.video-carousel__video');
    }

    function pauseAllVideos() {
      $section.querySelectorAll('.video-carousel__video').forEach(($video) => {
        if (!$video.paused) {
          $video.pause();
        }
      });
    }

    function pauseSlide($slide) {
      const $video = getVideo($slide);
      if ($video && !$video.paused) $video.pause();
    }

    function playSlide($slide) {
      const $video = getVideo($slide);
      if (!$video) return;
      pauseAllVideos();
      hasStartedPlaying = true;
      $video.muted = false;
      $video.play().catch(() => {});
    }

    function syncActiveSlide(swiperInstance) {
      swiperInstance.slides.forEach(($slide, index) => {
        if (index === swiperInstance.activeIndex) {
          if (hasStartedPlaying) playSlide($slide);
        } else {
          pauseSlide($slide);
        }
      });
    }

    // Delegated click handler (works across Swiper loop clones).
    // slideToClickedSlide (set below) already scrolls a non-active slide
    // into view; this starts that slide's video too, for both a fresh
    // click and a click on the already-active slide (which doesn't fire
    // its own slideChange).
    $section.addEventListener('click', (event) => {
      const $wrapper = event.target.closest('.video-carousel__wrapper');
      if (!$wrapper) return;

      const $slide = $wrapper.closest('.video-carousel__slide');
      if (!$slide) return;

      const $video = getVideo($slide);
      if (!$video) return;

      const isActiveSlide = swiper.slides[swiper.activeIndex] === $slide;
      if (isActiveSlide && !$video.paused) {
        pauseSlide($slide);
        return;
      }

      playSlide($slide);
    });

    // Toggle visual play state class on slide
    $section.addEventListener('play', (event) => {
      const $slide = event.target.closest('.video-carousel__slide');
      if ($slide) $slide.classList.add('is-playing');
    }, true);

    $section.addEventListener('pause', (event) => {
      const $slide = event.target.closest('.video-carousel__slide');
      if ($slide) $slide.classList.remove('is-playing');
    }, true);

    // Pause when scrolling the page
    window.addEventListener('scroll', pauseAllVideos, { passive: true });

    // Initialize Swiper
    const swiper = new Swiper($swiperEl, {
      loop: true,
      slidesPerView: slidesPerViewMobile,
      spaceBetween: gapMobile,
      centeredSlides: true,
      grabCursor: true,
      slideToClickedSlide: true,
      breakpoints: {
        768: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: gapDesktop,
        },
      },
      on: {
        slideChange: syncActiveSlide,
      },
    });
  });
}

initVideoSwiper();

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initVideoSwiper);
}
